export default {
    dlp: 'dlp',
    sanitization: 'sanitize',
    unarchive: 'unarchive'
};
